/** Must match NOTIF_CATEGORY in api-restful-node incentivesMarketCommsService */
export const EQUITY_MARKET_NOTIFICATION_CATEGORY = 'EQUITY_MARKET';
